import { CommonIcons } from "assets/common/icons";
import { FunctionComponent, SVGProps } from "react";

import { PATH } from "./path";

interface LinkItem {
  name:
    | string
    | FunctionComponent<
        SVGProps<SVGSVGElement> & { title?: string | undefined }
      >;
  to: string;
}

interface FooterLinks {
  partner: LinkItem;
  infos: LinkItem[];
  socials: LinkItem[];
}

export const FOOTER_LINKS: FooterLinks = {
  partner: {
    name: "",
    to: "#",
  },
  infos: [
    {
      name: "Giới thiệu về ACV88",
      to: PATH.AboutUs,
    },
    {
      name: "Phương thức liên hệ",
      to: PATH.ContactUs,
    },
    {
      name: "Chính sách bảo mật",
      to: PATH.Privacy,
    },
    {
      name: "Điều khoản điều kiện",
      to: PATH.Rule,
    },
    {
      name: "Câu hỏi thường gặp",
      to: PATH.FAQ,
    },
    {
      name: "Miễn trách nhiệm",
      to: PATH.Disclaimer,
    },
    {
      name: "Chơi có trách nhiệm",
      to: PATH.ResponsibleGambling,
    },
    {
      name: "Chính sách đại lý",
      to: PATH.Partner,
    },
  ],
  socials: [
    {
      name: CommonIcons.Facebook,
      to: "https://www.facebook.com/cskh.acv188",
    },
    {
      name: CommonIcons.Youtube,
      to: "https://www.youtube.com/@cskhacv188",
    },
    {
      name: CommonIcons.Telegram,
      to: "https://t.me/cskh_acv188",
    },
  ],
};

export const FOOTER_CONTENT_LINKS = [
  {
    name: "Giới thiệu về ACV88",
    to: PATH.AboutUs,
  },
  {
    name: "Phương thức liên hệ",
    to: PATH.ContactUs,
  },
  {
    name: "Chính sách bảo mật",
    to: PATH.Privacy,
  },
  {
    name: "Điều khoản điều kiện",
    to: PATH.Rule,
  },
  {
    name: "Câu hỏi thường gặp",
    to: PATH.FAQ,
  },
  {
    name: "Miễn trách nhiệm",
    to: PATH.Disclaimer,
  },
  {
    name: "Chơi có trách nhiệm",
    to: PATH.ResponsibleGambling,
  },
];
